import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserResponse } from 'app/shared/models/ei-models';

@Injectable({ providedIn: 'root' })
export class UserService {
    private baseUrl = '/api/users';

    constructor(private http: HttpClient) { }

    getUsers(filters: any): Observable<UserResponse[]> {
        let params = new HttpParams();
        Object.keys(filters).forEach(key => {
            if (filters[key]) {
                params = params.set(key, filters[key]);
            }
        });
        return this.http.get<UserResponse[]>(this.baseUrl, { params });
    }

    searchNome(term: string): Observable<string[]> {
        const params = new HttpParams().set('search', term);
        return this.http.get<string[]>(`${this.baseUrl}/search/nome`, { params });
    }

    searchImobiliarias(term: string): Observable<string[]> {
        const params = new HttpParams().set('search', term);
        return this.http.get<string[]>(`${this.baseUrl}/search/imobiliaria`, { params });
    }
}